<template>
  <div>
    <loading v-if="!isLoaded">Loading</loading>
    <div v-else>
      <form-textfield
        placeholder="Search for a file"
        @input="ResourceSearch"
        v-model="searchTerm"
      />
      <div v-if="selectedResource && !results">
        <p>
          <strong>Currently selected:</strong>
        </p>
        <resource-card :resource="selectedResource" />
      </div>
      <div v-else>
        <div v-if="searchTerm && results && results.length > 0">
          <h4>Results</h4>
          <div
            class="summary"
            v-for="file in results"
            :key="file.id"
            @click="setSelectedResource(file)"
          >
            <p>{{ file.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ResourceCard = () => import("@/components/ResourceCard.vue");
import debounce from "lodash/debounce";
export default {
  props: {
    showValidTick: {
      type: Boolean,
      default: false,
    },
    model: {
      type: String,
    },
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    value: {
      type: String,
    },
    fileTypes: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    ResourceCard,
  },

  data() {
    return {
      isLoaded: false,
      searchTerm: "",
      selectedResource: null,
      results: null,
    };
  },

  created() {
    this.isLoaded = true;
    this.selectedResource = JSON.parse(this.model);
  },

  methods: {
    reset() {
      this.isLoaded = false;
      this.$nextTick(() => {
        this.searchTerm = "";
        this.results = null;
        this.selectedResource = null;
        this.isLoaded = true;
      });
    },
    emitSelect(selectedOption, id) {
      this.$emit("change", JSON.stringify(selectedOption));
    },
    setSelectedResource(resource) {
      this.selectedResource = resource;
      this.results = null;
      this.searchTerm = "";
      this.emitSelect(resource);
    },
    ResourceSearch: debounce(function(query) {
      if (query.length < 1) {
        return;
      }
      this.$store.dispatch("files/listAllForSelect", query).then((results) => {
        const filtered = results
          .map((file) => {
            if (this.fileTypes.length < 1) {
              return file;
            }
            const ext = file.name.split(".")[1];
            return this.fileTypes.includes(ext) ? file : null;
          })
          .filter((item) => item);
        this.results = filtered;
      });
    }, 500),
  },
};
</script>

<style scoped lang="scss">
h4 {
  font-weight: 700;
  background: #e8edee;
  padding: 0.5em;
  margin-bottom: 0;
}

.summary {
  border: 1px solid #e8edee;
  padding: 0.5em;
  border-top: 0;
  cursor: pointer;

  &:hover {
    background: #f4f6f7;
  }

  p {
    margin: 0;
  }
}
</style>
